import { Link } from 'react-router-dom'
import { Compass } from 'lucide-react'
import { PageHeader, EmptyState, Button } from '@/components/ui'

export default function NotFound() {
  return (
    <>
      <PageHeader eyebrow="404" title={<>Page <b>not found</b></>} />
      <div className="card">
        <EmptyState
          icon={<Compass size={40} />}
          title="That route doesn't exist"
          hint="The page you're looking for isn't here."
          action={<Link to="/"><Button variant="primary">Back to Home</Button></Link>}
        />
      </div>
    </>
  )
}
